module.exports = __webpack_public_path__ + "img/9.f710b13f.webp";